import MyOffers from './my-offers';
import ReactDOM from 'react-dom';
import { getImgCDNDomain, getJSONFromHtml } from '../../domain/common';
import { IJsonBanner } from '../../domain/banners/interfaces';
import { IMyOffersProps } from './interfaces';
import { CSSProperties } from 'react';

const MY_OFFERS_ID = 'my-offers';
const ANIMATION_COUNT_STORAGE_KEY = 'my-offers-animation-count';
const ANIMATION_COUNT_MAX = 2;

/**
 * Get 'my offers' data from html.
 */
const getMyOffersData = () => {
    const data = getJSONFromHtml(document.getElementById('my-offers-json')) as IJsonBanner[];
    if(!data) return;

    // sort by priority
    // data.sort((item1, item2) => item1.bannerPriority - item2.bannerPriority);

    // fix image URLs
    const imgDomain = getImgCDNDomain();

    data.forEach(item => {
        item.bannerImage = imgDomain + item.bannerImage;
    });

    return data;
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-341
 */
const getMyOffersSettings = () : IMyOffersProps|null => {

    const data = getMyOffersData() as IJsonBanner[];
    if(!data) return null;

    const iconBG = document.getElementById('my-offers-icon-bgcolor')?.textContent || '';
    const panelBG = document.getElementById('my-offers-panel-bgcolor')?.textContent || '';
    const text = 'SPECIAL OFFERS';
    let isVisible = true;
    let textClass = '';
    let badgeClass = '';
    let rootClass = '';
    let style: CSSProperties|undefined = undefined;

    const animationCount = Number(window.sessionStorage.getItem(ANIMATION_COUNT_STORAGE_KEY)) || 0;

    let stripBG = '#ffffff';
    let stripColor = '#000000';
    let iconColor = '#000000';
    let theme = 'black-bg-yellow-text-white-circle';
    style = {
        boxShadow: '0 0 10px rgb(0, 0, 0, 0.4)',
    };

    if(animationCount < ANIMATION_COUNT_MAX) {
        window.sessionStorage.setItem(ANIMATION_COUNT_STORAGE_KEY, (animationCount + 1).toString());
        textClass = 'my-offers__pulse';
        rootClass = 'my-offers__slide-up';
    }

    return {
        data,
        text,
        stripBG,
        stripColor,
        iconBG,
        iconColor,
        panelBG,
        theme,
        isVisible,
        textClass,
        badgeClass,
        rootClass,
        style,
    };
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-1059
 * https://wavesaudio.atlassian.net/browse/DSWEB-1966
 * https://wavesaudio.atlassian.net/browse/DSWEB-3410 (AB test)
 */
export const initMyOffers = () => {

    const meta = document.querySelector('meta[name="hide-my-offers-footer"]');
    if(meta) return;

    let $root= document.getElementById(MY_OFFERS_ID) as HTMLElement;
    if(!$root){
        $root = document.createElement('div');
        $root.id = MY_OFFERS_ID;
        $root.className ='w-full fixed bottom-0';
        $root.style.zIndex = '100';
        document.body.appendChild($root);
    }

    const settings = getMyOffersSettings();
    if(!settings || !settings.isVisible) return;

    ReactDOM.render(
        <MyOffers
            {...settings}
        />,
        $root
    );
};
